module.exports = __webpack_public_path__ + "static/media/busloading.acbb4599.gif";